<lg-icon
    [icon]="convertor.getComment(current) ? 'icon-comment-edit' : 'icon-comment-add'"
    [lgTooltip]="getLocalCommentTooltip(current)"
    [lgTooltipDelay]="0"
    (click)="openLocalCommentDialog($event)"
    [clickable]="!isDisabled"
>
</lg-icon>
